import { useEffect, useState } from 'react';
import { getIndexedDBItem } from '../modules/utils/IndexedDB';

const useIndexDBValue = <T extends object>({ key }: { key: string }) => {
	const [value, setValue] = useState<T>();
	const [reTry, setReTry] = useState(0);

	useEffect(() => {
		if(!value) {
			getIndexDBValueByKey(key);
			setReTry(reTry + 1);
		}
	}, [reTry]);

	const getIndexDBValueByKey = async (key: string) => {
		try {
			const dbValue: T = await getIndexedDBItem(key);
			dbValue && setValue(dbValue);
		} catch (error) {
			console.error(error);
		}
	};

	return {
		value,
	};
};

export default useIndexDBValue;
